/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import cx from "classnames";
import { useTranslation } from "next-i18next";

import { Input } from "components";
import { useSearchInputLogic } from "./useSearchInputLogic";

import Button from "components/Button";
import { SearchButton } from "./SearchButton";

import ClearIcon from "resources/icons/x.svg";

import styles from "./SearchInput.module.scss";

export interface ISearchInputProps {
  className?: string;
}

export const SearchInput = ({ className }: ISearchInputProps) => {
  const { t } = useTranslation("translations");
  const {
    inputRef,
    searchPhrase,
    isInputExpanded,
    expandInput,
    handleClear,
    handleInputChange,
  } = useSearchInputLogic({ withExpand: true });

  return (
    <div
      className={cx(
        styles.searchContainer,
        {
          [styles.expanded]: isInputExpanded,
        },
        className
      )}
    >
      <SearchButton onClick={expandInput} />

      {isInputExpanded && (
        <>
          <Input
            ref={inputRef}
            type="text"
            value={searchPhrase}
            placeholder={t("web_search_input_field")}
            spellCheck={false}
            autoFocus={true}
            className={styles.inputContainer}
            inputClassName={styles.input}
            onChange={handleInputChange}
          />
          <Button
            size="small"
            variant="tertiary"
            aria-label="Clear"
            icon={<ClearIcon className={styles.clear} />}
            onClick={handleClear}
          />
        </>
      )}
    </div>
  );
};

export default SearchInput;
